import React from 'react';
import { Button } from './ui/Button';
import { Quote } from 'lucide-react';
export function FounderSection() {
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-95">
          {/* Image Side */}
          <div className="w-full lg:w-5/12" data-id="element-96">
            <div className="relative" data-id="element-97">
              <div className="absolute top-4 left-4 w-full h-full border-2 border-[#D4A843] rounded-lg transform translate-x-4 translate-y-4 z-0" data-id="element-98" />
              <img src="https://cdn.magicpatterns.com/uploads/fLwftKZJHYHmq983KNfD5Y/photo_2026-02-13_11-38-22.jpg" alt="Олена Водолажко — засновниця" className="relative z-10 w-full h-auto rounded-lg object-cover shadow-lg" data-id="element-99" />
            </div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-7/12" data-id="element-100">
            <div className="relative" data-id="element-101">
              <Quote className="absolute -top-10 -left-6 text-[#D4A843]/20 w-24 h-24 rotate-180" data-id="element-102" />

              <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-8 relative z-10" data-id="element-103">
                Звернення засновниці
              </h2>

              <div className="space-y-6 text-lg text-gray-700 relative z-10" data-id="element-104">
                <p data-id="element-105">Привіт усім!</p>
                <p data-id="element-106">
                  Мене звати Олена Водолажко. Я адвокат, юрист з великим
                  досвідом в регулюванні сфери азартних ігор та лотерей.
                </p>
                <p data-id="element-107">
                  Я запрошую Вас у ПРОСТІР ЧЕСНОЇ ГРИ, який я створила для всіх,
                  хто хоче і буде робити азарт в Україні чесним і
                  відповідальним, для тих, хто хоче грати ЧЕСНО і відповідально,
                  для тих, хто буде ЧЕСНО говорити про залежність і ЧЕСНО
                  допомагати тим, кому потрібна допомога і підтримка в боротьбі
                  із залежністю.
                </p>
                <p data-id="element-108">
                  Це ПРОСТІР для ЧЕСНОГО діалогу, підтримки, освіти, досліджень
                  і розвитку сфери азартних ігор і кожного, хто приєднається до
                  нього.
                </p>
                <p data-id="element-109">Ласкаво прошу!</p>
              </div>

              <div className="mt-10 mb-8" data-id="element-110">
                <div className="text-lg text-gray-700" data-id="element-111">З повагою,</div>
                <div className="text-2xl font-serif font-bold text-[#0A5E5C] mt-2" data-id="element-112">
                  Олена Водолажко
                </div>
                <div className="text-[#D4A843] font-medium mt-1" data-id="element-113">
                  Засновниця
                </div>
              </div>

              <Button variant="primary" size="lg" data-id="element-114">
                Прочитати більше
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}